<template>
  <div>
    <h1>Audio List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <p>
      <router-link
        :to="{ name: 'AudioCreate' }"
        class="btn btn-primary">Create</router-link>
    </p>

    <table class="table table-responsive table-striped table-hover">
      <thead :key="keyComponent">
        <tr>
          <th>Id</th>
          <th>
            <div class="d-flex aling-items-center justify-content-between">
              Name
              <div @click="sortByName">
                <span
                  v-if="sortName == 'asc'"
                  class="fas fa-sort-up"
                  aria-hidden="true"></span>
                <span
                  v-if="sortName == 'desc'"
                  class="fas fa-sort-down" 
                  aria-hidden="true"></span>
                <span
                  v-if="sortName == null"
                  class="fas fa-sort" 
                  aria-hidden="true"></span>                  
              </div>
            </div>                    
          </th>
          <th>
            <div class="d-flex aling-items-center justify-content-between">
              Created
              <div @click="sortByCreated">
                <span
                  v-if="sortCreated == 'asc'"
                  class="fas fa-sort-up"
                  aria-hidden="true"></span>
                <span
                  v-if="sortCreated == 'desc'"
                  class="fas fa-sort-down" 
                  aria-hidden="true"></span>
                <span
                  v-if="sortCreated == null"
                  class="fas fa-sort" 
                  aria-hidden="true"></span>                  
              </div>
            </div>                    
          </th>
          <th>Source Url</th>
          <th>Speaker</th>      
          <th>Testimonials</th>
          <th>View</th>
          <th>Edit</th>
          <!-- <th colspan="2"></th> -->
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in audioItems"
          :key="item['@id']">
          <th scope="row">
            <router-link
              v-if="item"
              :to="{name: 'AudioShow', params: { id: item['@id'] }}">
              {{ item['id'] }}
            </router-link>
          </th>
        <td>
            {{ item['name'] }}
        </td>
        <td>
            {{ item['created'] }}
        </td>
        <td style="word-break:break-all;">
            {{ item['sourceUrl'] }}
        </td>
        <td v-if="item['speaker'] != null">
            {{ item['speaker'].name }}
        </td>
        <td v-else>
        </td> 
        <td>
            <template v-if="item['testimonials'] != ''">
              <router-link                                
                :to="{ name: 'TestimonialListAudio', params: { id: item['id'] }}">
                {{ item['testimonials'].length }}
              </router-link>
            </template>
        </td>
          <td>
            <router-link
              :to="{name: 'AudioShow', params: { id: item['@id'] }}">
              <span
                class="fa fa-search"
                aria-hidden="true"></span>
              <span class="sr-only">Show</span>
            </router-link>
          </td>
          <td>
            <router-link :to="{name: 'AudioUpdate', params: { id: item['@id'] }}">
              <span
                class="fas fa-edit"
                aria-hidden="true"></span>
              <span class="sr-only">Edit</span>
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <nav class="my-3" aria-label="Page navigation" v-if="view">
      <router-link
        :to="view['hydra:first'] ? view['hydra:first'] : 'AudioContactList'"
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&lArr;</span> <span class="d-none d-sm-inline">First</span>
      </router-link>
      &nbsp;
      <router-link
        :to="!view['hydra:previous']? 'audio' : view['hydra:previous']"
        :class="{ disabled: !view['hydra:previous'] }"
        class="btn btn-primary">
        <span aria-hidden="true">&larr;</span> <span class="d-none d-sm-inline">Previous</span>
      </router-link>

      <router-link
        :to="view['hydra:next'] ? view['hydra:next'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Next <span aria-hidden="true">&rarr;</span>
      </router-link>

      <router-link
        :to="view['hydra:last'] ? view['hydra:last'] : '#'"
        :class="{ disabled: !view['hydra:next'] }"
        class="btn btn-primary">
        Last <span aria-hidden="true">&rArr;</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  data() {
    return {     
      successMessage: false,
      errorMessage: false,
      audioItems: null,
      sortName: null,
      sortCreated: null,
      sortField: null,
      keyComponent: 1
    }
  },
  computed: {
      ...mapFields('audio/del', {
          deletedItem: 'deleted',
      }),
      ...mapFields('audio/list', {
          error: 'error',
          items: 'items',
          isLoading: 'isLoading',
          view: 'view',
      }),     
      ...mapFields('speaker/list', {
      'speakerSelectItems': 'selectItems',
      }),
      routePath(){        
        return this.$route.fullPath;
      },
      routeParams(){
        console.log('Get params:', this.$route);      
        return this.$route.params;
      },
      routeQuery() {
        return this.$route.query;
      },
  },
  created() {
    if (localStorage.getItem('sortNameAudio')) {
      this.sortName = localStorage.getItem('sortNameAudio');
      this.sortField = { field: 'name', order: this.sortName };
    }
    if (localStorage.getItem('sortCreatedAudio')) {
      this.sortCreated = localStorage.getItem('sortCreatedAudio');
      this.sortField = { field: 'created', order: this.sortCreated };
    }
    if (!localStorage.getItem('sortNameAudio') && !localStorage.getItem('sortCreatedAudio')) {
      this.sortCreated = 'asc'
      this.sortField = { field: 'created', order: this.sortCreated };
    }
  },
  mounted() {    
    this.fetchAudio();
    this.speakersGetSelectItems();

    if (this.routeParams.success) {
      this.successMessage = this.routeParams.success;
    } else if (this.routeParams.error) {
      this.errorMessage = this.routeParams.error;
    } else {
      this.successMessage = false;
      this.successMessage = false;
    }
  },
  watch:{
    routePath(){
      this.getSortedPage({field: this.sortField.field, order:this.sortField.order, path: this.routePath, page: this.routeQuery.page})
    },
    items() {
      this.audioItems = this.items;
    }
  },
  methods: {
    ...mapActions({
      getPage: 'audio/list/default',
      speakersGetSelectItems: 'speaker/list/getSelectItems',
      getSortedPage: 'audio/list/getSortedItems'
    }),    
    sortByName() {
      // Remove other filters 
      this.sortCreated = null;
      localStorage.removeItem("sortCreatedAudio");      

      // Filter
      if (this.sortName == 'desc') {
        this.sortName = 'asc';
      } else if (this.sortName == 'asc') {
        this.sortName = 'desc';
      } else {
        this.sortName = 'desc';
      }
      // Save in local storage and in sorField configurator
      localStorage.setItem("sortNameAudio", this.sortName);
      this.sortField = { field: 'name', order: this.sortName };
      this.fetchAudio();     

      // Refresh header
      this.keyComponent += 1;
    },
    sortByCreated() {      
      // Remove other filters
      this.sortName = null;
      localStorage.removeItem("sortNameAudio");      

      // Filter
      if (this.sortCreated == 'desc') {
        this.sortCreated = 'asc';
      } else if (this.sortCreated == 'asc') {
        this.sortCreated = 'desc';
      } else {
        this.sortCreated = 'desc';
      }
      // Save in local storage and in sorField configurator
      localStorage.setItem("sortCreatedAudio", this.sortCreated);
      this.sortField = { field: 'created', order: this.sortCreated };
      this.fetchAudio();     

      // Refresh header
      this.keyComponent += 1;
    },
    fetchAudio() {
      if (this.routeQuery && this.routeQuery.page) {
        this.getSortedPage({field: this.sortField.field, order:this.sortField.order, page: this.routeQuery.page});
      } else {
        this.getSortedPage({field: this.sortField.field, order:this.sortField.order})
      }    
    }
  },
};
</script>
<style lang="scss">
  @media only screen and (min-width: 992px) {
    .table {
      display: table;     
    }
  } 
</style>


// WEBPACK FOOTER //
// src/components/audio/List.vue